import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Pagination from '@material-ui/lab/Pagination';
import { Table } from '../../components/Table';
import { StyledLink } from '../../components/Buttons';
import { Button, SearchInput } from '../../components/FormComponents';
import { apiUrl } from '../../api';
import PanelContentWrapper from '../../components/PanelContentWrapper';
import { Modal, ModalButtons } from '../../components/Modal';
import useDebounce from '../../hooks/debounce';
import { Permission } from '../../hooks/Permission';

const StyledTopWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    input {
        margin-right: 15px;
    }
`;

export const PromoProductsList = () => {
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [modalId, setModalId] = useState(null);
    const [change, setChange] = useState(0);
    const [items, setItems] = useState([]);

    const token = useSelector((store) => store.token);

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 1000, setPage);

    useEffect(() => {
        axios
            .get(`${apiUrl}/promoItem`, {
                params: {
                    page,
                    search: debouncedSearchTerm,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(({ data: { items: newItems, lastPage } }) => {
                setItems(newItems);
                setPages(lastPage);
            });
    }, [token, page, change, debouncedSearchTerm]);

    return (
        <>
            <Permission permission="promoItem-index" />
            <PanelContentWrapper>
                <StyledTopWrapper>
                    <SearchInput onChange={(e) => setSearchTerm(e.target.value)} />
                    <StyledLink to="/produkty-promocyjne/dodaj">Dodaj produkt</StyledLink>
                    <StyledLink to="/produkty-promocyjne/kategorie/dodaj">Dodaj kategorię</StyledLink>
                </StyledTopWrapper>

                <Table>
                    <thead>
                        <tr>
                            <th>Kategoria</th>
                            <th>Nazwa</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(({ id, name, category }) => (
                            <tr key={id}>
                                <td>{category}</td>
                                <td>{name}</td>
                                <td>
                                    <FontAwesomeIcon
                                        onClick={() => {
                                            setModalId(id);
                                        }}
                                        icon={faTrash}
                                        fixedWidth
                                    />
                                    <Link to={`/produkty-promocyjne/${id}`}>
                                        <FontAwesomeIcon icon={faArrowRight} fixedWidth />
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Pagination
                    count={pages}
                    page={page}
                    size="large"
                    shape="rounded"
                    onChange={(event, pageNumber) => {
                        setPage(pageNumber);
                    }}
                />
            </PanelContentWrapper>

            {modalId && (
                <Modal
                    closeModal={() => {
                        setModalId(null);
                    }}
                >
                    <p>Czy na pewno usunąć produkt promocyjny?</p>
                    <ModalButtons>
                        <Button
                            onClick={() => {
                                axios
                                    .delete(`${apiUrl}/promoItem/${modalId}`, {
                                        headers: {
                                            Authorization: `Bearer ${token}`,
                                        },
                                    })
                                    .then(() => {
                                        setChange(change + 1);
                                        setModalId(null);
                                    });
                            }}
                        >
                            Tak
                        </Button>
                        <Button
                            secondary
                            onClick={() => {
                                setModalId(null);
                            }}
                        >
                            Nie
                        </Button>
                    </ModalButtons>
                </Modal>
            )}
        </>
    );
};
